// Plugin to inject Google Site Verification meta tag at runtime
// This allows K8s environment variables to be picked up properly
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  // Only inject meta tag if NUXT_PUBLIC_GOOGLE_SITE_VERIFICATION env var is set
  // In staging this will be empty, in production it will contain the verification code
  if (config.public.GOOGLE_SITE_VERIFICATION) {
    useHead({
      meta: [
        {
          name: "google-site-verification",
          content: config.public.GOOGLE_SITE_VERIFICATION,
        },
      ],
    });
  }
});
